<template>
    <div class="read_preview">
        <headers :title='titles'></headers>
        <div v-if="loading">
            <div v-if="true">
                <div v-for="(book,index) in bookList"
                     v-if="bookList.length">
                    <div class="book_list">
                        <div class="title">
                            <p>{{book.title}}</p>
                        </div>
                        <div class="text">
                            <p v-for="b in book.pool_list">{{b.audio_text}}</p>
                        </div>
                    </div>
                </div>
                <div v-if="wordList.length">
                    <ul class="word_list">
                        <h3>单词（{{wordList.length}}）</h3>
                        <li v-for="(word,index) in wordList"
                            class="clearfix">
                            <p>{{word.word}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';

export default {
    data () {
        return {
            titles: '习题预览',
            sid: this.$route.params.sid,
            message_id: this.$route.params.message_id,
            task_type: this.$route.params.task_type,
            bookList: [],
            wordList: [],
            qids: [],
            loading: true,
        }
    },
    components: {
        loadingS, headers
    },
    methods: {},
    async created () {
        await this.$http.post(API_URL_TASK_API + '/english/task/word', {
            message_id: this.message_id,
            sid: this.sid,
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                if (Object.keys(res.data).length) {
                    this.wordList = res.data.word_list;
                }
            }
        });
        await this.$http.post(API_URL_TASK_API + '/english/task/text', {
            message_id: this.message_id,
            sid: this.sid,
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.bookList = res.data;
            }
        })
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.read_preview {
    font-size: 30px / $ppr;
    color: #333;
    padding-bottom: 100px / $ppr;
}

.book_list {
    margin-bottom: 25px / $ppr;
    background: #fff;
    .title,
    .text {
        line-height: 46px / $ppr;
        padding: 25px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
        word-wrap: break-word;
    }
    .title {
        position: relative;
    }
}

.word_list {
    line-height: 96px / $ppr;
    background: #fff;
    h3,
    li {
        padding: 0 25px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
    }
    li:last-child {
        border-bottom: none;
    }
    li {
        p {
            float: left;
            width: 400px / $ppr;
        }
    }
}
</style>
